import type { SanityPageBuilderSection, SanityPageBuilderShopProductSection } from "@ouster/shared";
import { ShopProductBlockView, type ShopProductBlockViewProps } from "~/features/blocks/inventory/shop-product";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
import { toCraftAsset } from "~/features/sanity/media";
import { hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderShopProductSection;
  };
};
function formatPrice(price?: number) {
  return typeof price === "number" ? `$${price.toFixed(2)}` : undefined;
}

// Rich-text values are Portable Text arrays; treat empty/absent as no content.
function hasRichText(value?: unknown) {
  return Array.isArray(value) && value.length > 0;
}
export function SanityShopProductSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const product = sectionContent.product;
  const accordions: NonNullable<ShopProductBlockViewProps["accordions"]> = [];
  if (hasRichText(product?.details)) {
    accordions.push({
      title: "Details",
      body: <SanityRichText value={product?.details} />
    });
  }
  if (hasRichText(product?.materials)) {
    accordions.push({
      title: "Materials",
      body: <SanityRichText value={product?.materials} />
    });
  }
  return <ShopProductBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} theme={sectionSettings?.theme || "white"} productSlug={product?.slug} title={product?.title} price={formatPrice(product?.price)} description={hasRichText(product?.description) ? <SanityRichText value={product?.description} /> : undefined} image={hasRenderableSanityMedia(product?.image) ? <Asset asset={toCraftAsset(product?.image) as AssetProps["asset"]} imageProps={{
    fit: "contain",
    sizes: "lg:60vw"
  }} /> : undefined} sizeOptions={product?.sizeOptions} specs={product?.specs} accordions={accordions} limitNote={product?.limitNote} soldOut={product?.soldOut} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} />;
}